<template>
  <div class="relative">
    <!-- Botão Esquerdo -->
    <button
      @click="scroll(-scrollAmount)"
      aria-label="Scroll Left"
      class="absolute left-0 top-1/2 -translate-y-1/2 z-10 p-2 bg-black bg-opacity-50 hover:bg-opacity-75 h-full"
    >
      <!-- SVG de seta para a esquerda -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 text-white"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M15 19l-7-7 7-7"
        />
      </svg>
    </button>

    <!-- Container rolável -->
    <div ref="container" class="flex overflow-x-hidden scroll-smooth space-x-4">
      <slot />
    </div>

    <!-- Botão Direito -->
    <button
      @click="scroll(scrollAmount)"
      aria-label="Scroll Right"
      class="absolute right-0 top-1/2 -translate-y-1/2 z-10 p-2 bg-black bg-opacity-50 hover:bg-opacity-75 h-full"
    >
      <!-- SVG de seta para a direita -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 text-white"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'

// referência ao div rolável
const container = ref(null)

// distância fixa de scroll (ajuste conforme a largura do card + gap)
const scrollAmount = 300

function scroll (distance) {
  if (!container.value) return
  container.value.scrollBy({ left: distance, behavior: 'smooth' })
}
</script>

<style scoped>
/* opcional: esconder a scrollbar, se quiser */
div::-webkit-scrollbar {
  display: none;
}
</style>
